import React from "react";
import { Row, Col, Button, MessageBanner } from "@folio/stripes/components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { firstOnix } from "../../utils/selectMappers";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { useItemEditor } from "../../hooks/title/useItemEditor";
import { useContentRows } from "../../utils/toContentRows";
import { FormSectionModal } from "./FormSectionModal";
import { useFieldArrayErrors } from "../../hooks/useFieldArrayErrors";
import { EntityRowList } from "./EntityRowList";
import css from "./FormModal.module.css";
var TitleAudiencesForm = function () {
    var _a;
    var formatMessage = useIntl().formatMessage;
    var _b = useFormContext(), control = _b.control, getValues = _b.getValues;
    var errorMessages = useFieldArrayErrors("audiences");
    var _c = useFieldArray({ control: control, name: "audiences" }), audienceFields = _c.fields, appendAudience = _c.append, updateAudience = _c.update, removeAudience = _c.remove;
    var _d = useOnixOptions(), audienceTypeTable = _d.audienceTypeTable, audienceTypeLoading = _d.audienceTypeLoading, audienceTypeStatus = _d.audienceTypeStatus;
    var _e = useItemEditor({
        appendItem: appendAudience,
        updateItem: updateAudience,
        createEmpty: function () { return ({
            type: firstOnix(audienceTypeTable === null || audienceTypeTable === void 0 ? void 0 : audienceTypeTable.onixCodetableItems),
        }); },
    }), isOpen = _e.isOpen, isEditing = _e.isEditing, draft = _e.draft, setDraft = _e.setDraft, openEditor = _e.openEditor, closeEditor = _e.closeEditor, saveItem = _e.saveItem;
    var contentData = useContentRows(audienceFields);
    var columns = [
        {
            name: formatMessage({ id: "ui-br-agency.title.audiences.type.label" }),
            cellRenderer: function (row) { var _a; return ((_a = row.type) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 }, audienceFields.length > 0 ? (React.createElement(EntityRowList, { data: contentData, columns: columns, onEdit: function (row) {
                    return openEditor(getValues("audiences.".concat(row._index)), row._index);
                }, onDelete: function (row) { return removeAudience(row._index); } })) : (React.createElement("div", { className: css.emptyState },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.audiences.empty" }))))),
        errorMessages.length > 0 && (React.createElement(Row, { "data-error-field": "audiences" },
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: "error", className: css.tableErrorBanner }, errorMessages.map(function (msg) { return (React.createElement("div", { key: msg }, msg)); }))))),
        React.createElement(FormSectionModal, { open: isOpen, isEditing: isEditing, draft: draft, onDraftChange: setDraft, onSave: saveItem, onClose: closeEditor, addLabelId: "ui-br-agency.title.audiences.form.add.title", editLabelId: "ui-br-agency.title.audiences.form.edit.title", fields: [
                {
                    key: "type",
                    labelId: "ui-br-agency.title.audience.type.label",
                    type: "onix",
                    required: true,
                    colSpan: 12,
                    dataOptions: (_a = audienceTypeTable === null || audienceTypeTable === void 0 ? void 0 : audienceTypeTable.onixCodetableItems) !== null && _a !== void 0 ? _a : [],
                    loading: audienceTypeLoading,
                    codetableStatus: audienceTypeStatus,
                },
            ], validate: function (d) { var _a; return !!((_a = d.type) === null || _a === void 0 ? void 0 : _a.value); } }),
        React.createElement(Row, { className: css.actions },
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return openEditor(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.add.audience" }))))));
};
export default TitleAudiencesForm;
